import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Typography } from '../../../../ui-kit';
import { refetchGetCurrentVenueCustomPaymentMethodsQuery, useCreateCustomPaymentMethodMutation } from '../../../../generated/graphql';
import { sanitizeFormValues } from '../../../../utils';
import { routePaths } from '../../../../routePaths';
import { LocationReferrer } from '../../../../types/locationReferrer';
import CustomPaymentMethodForm from './CustomPaymentMethodForm';
import { OnSubmit } from './types';

const CreateCustomPaymentMethodForm = () => {
    const { t } = useTranslation();
    const history = useHistory<LocationReferrer>();
    const { state = {} } = history.location;
    const { referrer } = state;
    const [createCustomPaymentMethod] = useCreateCustomPaymentMethodMutation({
        refetchQueries: [refetchGetCurrentVenueCustomPaymentMethodsQuery({ onlyActive: false })]
    });

    const handleSubmit: OnSubmit = async formValues => {
        const sanitizedFormValues = sanitizeFormValues(formValues);
        try {

            await createCustomPaymentMethod({ variables: { data: sanitizedFormValues } });
            history.push(referrer ||routePaths.customPaymentMethodsSettings);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Card>
            <Box px={3} py={5}>
                <Typography variant='h6' component='h1'>{t('Create custom payment method')}</Typography>
                <CustomPaymentMethodForm onSubmit={handleSubmit} submitText={t('Create')} />
            </Box>
        </Card>
    );
};

export default CreateCustomPaymentMethodForm;
